import {
  FeriasService
} from "../../../../services/FeriasService";

import AgendarFerias from "../../agendar-ferias/AgendarFerias.vue";

export default {
  name: "MilitaresFeriasAVencer",

  props: {
    optionsFilter: {}
  },

  watch: {
    page: function (val) {
      this.page = val;
      this.pegarMilitaresSemAgendamentoFerias();
    },
  },
  components: {
    AgendarFerias
  },

  data: () => ({
    dialog: false,

    AgendarFeriasDialog: false,

    headers: [{
        text: "Militar",
        value: "nome",
        width: "10%"
      },
   
    ],

    items: [],
    page: 1,
    pageCount: 0,
    totalItems: 0,
  }),

  async beforeMount() {
    await this.pegarMilitaresFeriasAVencer();

  },
  methods: {
    confirmAction() {
      this.$emit("confirmAction");
    },

    async pegarMilitaresFeriasAVencer() {
      const filter = new FormData();
      filter.append("page", this.page);
      filter.append("id_unidade", this.$store.state.user.Unidade.id);

      const response = await FeriasService.getFeriasParaVencer(filter);
      this.items = response.data;
      if(response.data.length == 0){
          this.$emit("confirmAction");
        }
      this.pageCount = response.last_page;
      this.totalItems = response.total;
    },
  },
};